import React, { Component } from "react";
import { Subscribe } from "unstated";

import buttonActionHelper from "../../../utils/helpers/buttonActionHelper";
import StateContainer from "../../../state/StateContainer";

class DefaultButton extends Component {
  state = {
    isHovered: false,
  };


  render() {
    const button = this.props.buttonData
    return (
      <Subscribe to={[StateContainer]}>
        {(state2) => (
                <button
                  key={button.name}
                  style={button.iconUrl?{ backgroundImage: `Url(${this.state.isHovered? (button.hoverIconUrl?button.hoverIconUrl:button.iconUrl):button.iconUrl})` }:{display: "block"}}
                  className={this.props.buttonClass}
                  onClick={() => {
                    buttonActionHelper.executeActions(
                      button.actions,
                      state2,
                      "click"
                    );
                  }}
                  onMouseEnter={() => {
                    this.setState({isHovered: true})
                    buttonActionHelper.executeActions(
                      button.actions,
                      state2,
                      "mouseenter"
                    );
                  }}
                  onMouseLeave={() => {
                    this.setState({isHovered: false})
                    buttonActionHelper.executeActions(
                      button.actions,
                      state2,
                      "mouseleave"
                    );
                  }}
                >{button.text}</button>
        )}
      </Subscribe>
    );
  }
}

export default DefaultButton;
